import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export type PartnerWorkerDetailExperienceProps = {
  data: {
    salaryScale?: number;
    salaryStep?: number;
    contractHours?: number;
    startDate?: string;
    endDate?: string;
  };
};

export const PartnerWorkerDetailExperience = (props: PartnerWorkerDetailExperienceProps) => {
  const { t } = useTranslation('partner-screen-specific');
  return (
    <Grid container spacing={2}>
      <Grid item xs={4}>
        <Typography variant="subtitle1">{t('partner_worker_detail.salary_scale')}</Typography>
        <Typography variant="body1">{props.data.salaryScale ?? '--'}</Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography variant="subtitle1">{t('partner_worker_detail.salary_step')}</Typography>
        <Typography variant="body1">{props.data.salaryStep ?? '--'}</Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography variant="subtitle1">{t('partner_worker_detail.contract_hours')}</Typography>
        <Typography variant="body1">{props.data.contractHours ?? '--'}</Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography variant="subtitle1">{t('partner_worker_detail.start_date')}</Typography>
        <Typography variant="body1">{props.data.startDate ?? '--'}</Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography variant="subtitle1">{t('partner_worker_detail.end_date')}</Typography>
        <Typography variant="body1">{props.data.endDate ?? '--'}</Typography>
      </Grid>
    </Grid>
  );
};
